import { render } from "./NameExtend.vue?vue&type=template&id=0159265b"
import script from "./NameExtend.vue?vue&type=script&lang=js"
export * from "./NameExtend.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__